import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { classNames } from "../../helpers/classNames";
 
const UserLayout = () => {
  return (
    <>
      <section className="relative py-4 overflow-hidden bg-md-pink-light-2">
        {/* <div className={classNames("relative w-full px-16 mx-auto")}> */}
            {/* <div className="flex items-start gap-4 3xl:gap-6"> */}
              {/* <div className="relative flex-shrink flex-grow"> */}
                <Outlet />
              {/* </div> */}
            {/* </div> */}
        {/* </div> */}
      </section>
    </>
  );
};
 
export default UserLayout;